export default __webpack_public_path__ + "static/media/featured-item-19.ea658027.png";